import Paragraph from '@tiptap/extension-paragraph';

/**
 * Change the tag from <p> to <div>
 */
export default Paragraph.extend({
  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['div', HTMLAttributes, 0];
  },

  parseHTML() {
    return [
      { tag: 'div' },
    ];
  },
});
